//日志管理
const LoginLog = () => import(/*webpackChunkName:'system'*/'@/page/system/log/conLog.vue')
const OperationLog = () => import(/*webpackChunkName:'system'*/'@/page/system/log/operationLog.vue')
const AbnormalLog = () => import(/*webpackChunkName:'system'*/"@/page/system/log/abnormalLog.vue")
const RouteTemp = () => import(/*webpackChunkName:'system'*/'@/page/commons/routeTemp.vue')

export const log={
    path: '/main/log',
    name: '日志管理',
    component: RouteTemp,
    meta: {
        requireAuth: true,
    },
    children: [{
        path: '/main/log/conLog',
        name: '登录日志',
        component: LoginLog,
        meta: {
            requireAuth: true,
        },
    }, {
        path: '/main/log/operation',
        name: '操作日志',
        component: OperationLog,
        meta: {
            requireAuth: true,
        },
    }, {
        path: '/main/log/abnormal',
        name: '异常日志',
        component: AbnormalLog,
        meta: {
            requireAuth: true,
        },
    }]
}